/**
 * @file Génère un objet JSON-LD de type Organization pour Schema.org
 * @description Ce module fournit un schéma structuré représentant la Ville de Longueuil
 *              en tant qu'organisation, destiné à être utilisé pour le SEO (rich snippets).
 * @author Roger Sioufi roger.sioufi[at]makeitbloom.com
 */

/**
 * Retourne un schéma JSON-LD représentant l’organisation « Ville de Longueuil ».
 *
 * @returns Objet conforme au type "Organization" du vocabulaire Schema.org
 */
export function getOrganizationSchema() {
    return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Ville de Longueuil',
        url: 'https://longueuil.quebec/fr',
        description:
            "Site officiel de la Ville de Longueuil. Retrouvez toute l'information municipale : services aux citoyens, activités, urbanisme, développement économique et plus encore.",
        logo: 'https://longueuil.quebec/logo.png',
        contactPoint: {
            '@type': 'ContactPoint',
            telephone: '+1-450-463-7311',
            contactType: 'customer support',
            email: '311@longueuil.quebec',
        },
        sameAs: [
            'https://www.facebook.com/villedelongueuil',
            'https://x.com/villelongueuil',
            'https://www.instagram.com/ville_longueuil',
            'https://www.linkedin.com/company/ville-de-longueuil',
            'https://www.youtube.com/user/VilledeLongueuil',
        ],
        location: {
            '@type': 'Place',
            name: 'Longueuil',
            address: {
                '@type': 'PostalAddress',
                streetAddress: '4250, chemin de la Savane',
                addressLocality: 'Longueuil',
                addressRegion: 'QC',
                postalCode: 'J3Y 9G4',
                addressCountry: 'CA',
            },
        },
        member: [
            {
                '@type': 'Person',
                name: 'Catherine Fournier',
                jobTitle: 'Mairesse',
            },
        ],
    };
}
